module.exports = __webpack_public_path__ + "static/media/pickup_color.443f45cd.svg";